<template>
  <div :style="containerStyle">
    <div class="inbox-message">
      <ul>
        <li v-for="(n, idx) in notifications" :key="'notification_' + idx">
            <div class="message-avatar">
                <img v-if="n.alertSeverityId == 1001" src="../assets/images/warn.png" alt />
                <img v-else src="../assets/images/info.png" alt />
            </div>
          <div class="message-body">
            <div class="message-body-heading">
              <h5>{{getNotificationArea(n)}}</h5>
              <span>{{n.dateCreatedLabel}}</span>
            </div>
            <p>{{n.title}}</p>
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-secondary">
                <input
                  type="radio"
                  name="options"
                  id="option1"
                  autocomplete="off"
                  v-on:click="deleteNotification(idx, n.id)"
                /> Delete
              </label>
              <label class="btn btn-secondary">
                <input
                  type="radio"
                  name="options"
                  id="option2"
                  autocomplete="off"
                  v-on:click="dismissNotification(idx, n.id)"
                /> Dismiss
              </label>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { notificationApiService } from "@/services/notification-api.service";

export default {
  name: "ClaimNotifications",
  props: ["claimId", "width"],
  data: () => {
    return {
      notifications: []
    };
  },
  watch: {
    claimId: function(newVal) {
      notificationApiService
        .get({ claimId: newVal })
        .then(response => {
          let { data } = response;
          this.notifications = data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    notifications: function(newVal) {
      if (newVal) {
        this.$emit("notification-count", newVal.length);
      }
    }
  },
  computed: {
    containerStyle() {
      if (this.width) {
        return {
          "overflow-y": "auto",
          "max-height": "100%",
          "max-width": this.width,
          "min-width": this.width
        }
      } else {
        return {
          "overflow-y": "auto",
          "max-height": "100%",
          "max-width": '500px',
          "min-width": '500px'
        }
      }
    }
  },
  methods: {
    getNotificationArea(obj) {
      if (obj && obj.settlementOptionId > 0) {
        return "Settlement option";
      } else {
        return "General";
      }
    },
    dismissNotification(idx, id) {
      notificationApiService
        .cancelForUser({ Id: id })
        .then(response => {
          this.notifications.splice(idx, 1);
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteNotification(idx, id) {
      notificationApiService
        .cancel({ Id: id })
        .then(response => {
          this.notifications.splice(idx, 1);
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  beforeMount() {
    notificationApiService
      .get({ claimId: this.claimId })
      .then(response => {
        let { data } = response;
        this.notifications = data;
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>
<style scoped>
.inbox-controller {
  overflow-y: auto;
  max-height: 100%;
  max-width: 500px;
  min-width: 500px;
}
/*=====================================
Inbox Message Style
=======================================*/
.inbox-message ul {
  padding: 0;
  margin: 0;
}
.inbox-message ul li {
  list-style: none;
  position: relative;
  padding: 15px 20px;
  border-bottom: 1px solid #e8eef1;
}
.inbox-message ul li:hover,
.inbox-message ul li:focus {
  background: #eff6f9;
}
.inbox-message .message-avatar {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}
    .message-avatar img {
        display: inline-block;
        width: 54px;
        height: 54px;
        /*border-radius: 50%;*/
    }
.inbox-message .message-body {
  margin-left: 85px;
  font-size: 15px;
  color: #62748f;
}
.message-body-heading h5 {
  font-weight: 600;
  display: inline-block;
  color: #62748f;
  margin: 0 0 7px 0;
  padding: 0;
}
.message-body h5 span {
  border-radius: 50px;
  line-height: 14px;
  font-size: 12px;
  color: #fff;
  font-style: normal;
  padding: 4px 10px;
  margin-left: 5px;
  margin-top: -5px;
}
.message-body h5 span.unread {
  background: #07b107;
}
.message-body h5 span.important {
  background: #dd2027;
}
.message-body h5 span.pending {
  background: #2196f3;
}
.message-body-heading span {
  float: right;
  color: #62748f;
  font-size: 14px;
}
.messages-inbox .message-body p {
  margin: 0;
  padding: 0;
  line-height: 27px;
  font-size: 15px;
}

a:hover {
  text-decoration: none;
}
</style>